export default __webpack_public_path__ + "static/media/ME.cd3656ad.svg";